import { appRoutes } from '../../../../path';

export const usersPageNav = [
  { label: 'All Users', url: appRoutes.permission.allUsers },
  { label: 'Pending Users', url: appRoutes.permission.pendingUsers },
];
